var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hasData flex items-center justify-center bg-white px-6"},[_c('img',{attrs:{"src":require("@/assets/images/elements/has-data.png")}}),_c('h5',[_vm._v(_vm._s(_vm.$t('sorryDataTable')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }